import { useMutation } from "@tanstack/vue-query";

import commentService from "@/services/modules/comments";

import type { Comment } from "@/schemas/comment";

export const useUpdateCommentMutation = () => {
  return useMutation({
    mutationFn: async (comment: Comment) =>
      await commentService.update(comment),
  });
};

export const useResolveCommentMutation = () => {
  return useMutation({
    mutationFn: async (commentId: Comment["id"]) =>
      await commentService.resolve(commentId),
  });
};

export const useUnresolveCommentMutation = () => {
  return useMutation({
    mutationFn: async (commentId: Comment["id"]) =>
      await commentService.unresolve(commentId),
  });
};
